import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=36771134&scoped=true"
import script from "./disclaimer.vue?vue&type=script&lang=js"
export * from "./disclaimer.vue?vue&type=script&lang=js"
import style0 from "./disclaimer.vue?vue&type=style&index=0&id=36771134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36771134",
  null
  
)

export default component.exports